import '../../styles/index.scss';
import { docReady } from '../helpers/docReady';
docReady(() => {
    console.log('Global JS Ready');
});
